<template>
  <div>
    <v-data-table
      :headers="(tipo === 'PD') ? $vuetify.breakpoint.width >= 991 ? headersExigenciasRelatorioPredicao[idioma][0] : headersExigenciasRelatorioPredicao[idioma][1] :$vuetify.breakpoint.width >= 991 ? headersExigenciasRelatorio[idioma][0] : headersExigenciasRelatorio[idioma][1]"
      :items="Object.values(composicao_dieta)"
      hide-actions
      item-key="id"
      fixed-header
      class="table-exigencias table-relatorio"
    >
      <template v-slot:headers="props">
        <tr>
          <template v-for="(header) in props.headers.filter(h => h.text !== 'Max')">
            <th
              :key="header.text"
              :style="textAlignHeader(header, (tipo === 'PD') ? headersExigenciasRelatorioPredicao[idioma] : headersExigenciasRelatorio[idioma])"
            >
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr
          v-if="exigencias_resultados[props.item.id]"
          :style="props.expanded ? 'background-color: #ababab' : ''"
          :class="exigencias_resultados[props.item.id].divider && !props.expanded ? 'divider-exigencia' : ''"
          :active="(exigencias[props.item.id]) ? exigencias[props.item.id].selecionado : false"
          @click.stop="(props) ? (props.expanded = !props.expanded) : null"
        >
          <td
            v-if="$vuetify.breakpoint.width >= 991"
            style="width: 40%"
          >
            <v-icon
              v-if="Object.values(props.item.alimentos).length"
              :color="(props.expanded) ? 'black' : ''">{{ (props.expanded) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>

            <strong>{{ exigencias_resultados[props.item.id].exigencia[idioma] }}</strong>
          </td>
          <td
            v-if="$vuetify.breakpoint.width >= 991"
            style="padding-right: 40px"><strong>{{ exigencias_resultados[props.item.id].codigo[idioma] }}</strong></td>
          <td v-if="$vuetify.breakpoint.width >= 991"><strong>{{ exigencias_resultados[props.item.id].unidade[idioma] }}</strong></td>
          <td v-else>
            <v-layout column>
              <strong>{{ exigencias_resultados[props.item.id].codigo[idioma] }}</strong>
              ({{ exigencias_resultados[props.item.id].unidade[idioma] }})
            </v-layout>
          </td>
          <td>
            <v-text-field
              v-if="exigencias[props.item.id] === undefined"
              value="-"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-money="optionsNumber.float2[idioma]"
              v-else-if="exigencias[props.item.id].minimo !== '-' && parseString(exigencias[props.item.id].minimo, idioma) !== 0"
              v-model.lazy="exigencias[props.item.id].minimo"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-else
              value="-"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
          </td>
          <td>
            <v-text-field
              v-money="optionsNumber.float2[idioma]"
              v-if="(props.item.id === 'AMIDO' || props.item.id === 'FDNfe') && Object.values(props.item.alimentos).length > 0"
              :value="props.item.total.toFixed(2)"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="props.item.id === 'AMIDO' || props.item.id === 'FDNfe'"
              :value="'-'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="props.item.total === 0"
              :value="(idioma === 0)?'-': '-'"
              :class="Object.values(props.item.alimentos).length ? renderInputTotal(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputTotal(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"
              :style="Object.values(props.item.alimentos).length ? renderInputStyle(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputStyle(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"

              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="props.item.total < 0.009"
              :value="(idioma === 0)?'< 0,01': '< 0.01'"
              :class="Object.values(props.item.alimentos).length ? renderInputTotal(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputTotal(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"
              :style="Object.values(props.item.alimentos).length ? renderInputStyle(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputStyle(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"

              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-money="optionsNumber.float2[idioma]"
              v-else
              :value="Object.values(props.item.alimentos).length ? props.item.total.toFixed(2) : '0.00'"
              :class="Object.values(props.item.alimentos).length ? renderInputTotal(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputTotal(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"
              :style="Object.values(props.item.alimentos).length ? renderInputStyle(parseFloat(Object.values(props.item.alimentos).map(el => el.valor).reduce((cont, curr) => cont + curr).toFixed(2)), exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id) : renderInputStyle(0, exigencias[props.item.id].minimo, exigencias[props.item.id].maximo, props.item.id)"

              readonly
              color="primary"
              outline
            />
          </td>
          <td v-if="$vuetify.breakpoint.width >= 991">
            <v-text-field
              v-if="exigencias[props.item.id] === undefined"
              value="-"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-money="optionsNumber.float2[idioma]"
              v-else-if="exigencias[props.item.id].maximo !== '-'"
              v-model.lazy="exigencias[props.item.id].maximo"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="exigencias[props.item.id].maximo < 0.009"
              :value="(idioma === 0)?'< 0,01': '< 0.01'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else
              v-model="exigencias[props.item.id].maximo"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
          </td>
          <td>
            <v-text-field
              v-if="exigencias[props.item.id] === undefined && props.item.pcms === 0"
              :value="'-'"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="exigencias[props.item.id] === undefined && props.item.pcms < 0.009"
              :value="(idioma === 0 || idioma === 2)?'< 0,01': '< 0.01'"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MS' : '%/DM'"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-money="renderMask(['', '', ''], ['', '', ''], idioma)"
              v-else-if="exigencias[props.item.id] === undefined"
              :value="Object.values(props.item.alimentos).length ? props.item.pcms.toFixed(2) : '0.00'"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MS' : '%/DM'"
              readonly
              class="text-field-table input-disabled"
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="(props.item.cms_pv) && (props.item.id === 'CMS') && props.item.cms_pv === 0"
              :value="'-'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="(props.item.cms_pv) && (props.item.id === 'CMS') && props.item.cms_pv < 0.009"
              :value="(idioma === 0 || idioma === 2)?'< 0,01': '< 0.01'"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MN' : '%/NM'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-money="renderMask(['', '', ''], ['', '', ''], idioma)"
              v-else-if="(props.item.cms_pv) && props.item.id === 'CMS'"
              :value="((parseFloat(composicao_dieta.CMS.total) / parseFloat(composicao_racao.MN.total)) * 100).toFixed(2)"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MN' : '%/NM'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="(props.item.id === 'EL' || props.item.id === 'EM') && props.item.mcal === 0"
              :value="'-'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="(props.item.id === 'EL' || props.item.id === 'EM') && props.item.mcal < 0.009"
              :value="(idioma === 0 || idioma === 2)?'< 0,01': '< 0.01'"
              :suffix="(idioma === 0 || idioma === 2) ? 'Mcal/kg' : 'Mcal/kg'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-money="renderMask(['', '', ''], ['', '', ''], idioma)"
              v-else-if="(props.item.id === 'EL' || props.item.id === 'EM')"
              :value="Object.values(props.item.alimentos).length ? props.item.mcal.toFixed(2) : '0.00'"
              :suffix="(idioma === 0 || idioma === 2) ? 'Mcal/kg' : 'Mcal/kg'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="exigencias[props.item.id].micromineral && props.item.mg === 0"
              :value="'-'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="exigencias[props.item.id].micromineral && props.item.mg < 0.009"
              :value="(idioma === 0 || idioma === 2)?'< 0,01': '< 0.01'"
              :suffix="(idioma === 0 || idioma === 2) ? 'mg/kg' : 'mg/kg'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-money="renderMask(['', '', ''], ['', '', ''], idioma)"
              v-else-if="exigencias[props.item.id].micromineral"
              :value="Object.values(props.item.alimentos).length ? props.item.mg.toFixed(2) : '0.00'"
              :suffix="(idioma === 0 || idioma === 2) ? 'mg/kg' : 'mg/kg'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="props.item.pcms === 0"
              :value="'-'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-else-if="props.item.pcms < 0.009"
              :value="(idioma === 0 || idioma === 2)?'< 0,01': '< 0.01'"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MS' : '%/DM'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
            <v-text-field
              v-money="renderMask(['', '', ''], ['', '', ''], idioma)"
              v-else
              :value="Object.values(props.item.alimentos).length ? props.item.pcms.toFixed(2) : '0.00'"
              :suffix="(idioma === 0 || idioma === 2) ? '%/MS' : '%/DM'"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
          </td>
        </tr>
        <tr
          v-else-if="parseString(props.item.total, idioma) !== 0"
          :style="props.expanded ? 'background-color: #ababab' : ''"
          :class="!props.expanded ? 'divider-exigencia' : ''"
          @click.stop="(props) ? (props.expanded = !props.expanded) : null"
        >
          <td v-if="$vuetify.breakpoint.width >= 991"><strong><v-icon
            v-if="Object.values(props.item.alimentos).length"
            :color="(props.expanded) ? 'black' : ''">{{ (props.expanded) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            {{ (idioma === 0) ? props.item.exigencia : props.item.exigencia_en }}</strong></td>
          <td v-else>
            <v-layout column>
              <strong>{{ props.item.sigla ? props.item.sigla : props.item.id }}</strong>
              ({{ props.item.unidade[idioma] }})
            </v-layout>
          </td>
          <td v-if="$vuetify.breakpoint.width >= 991"><strong>{{ props.item.sigla ? props.item.sigla : props.item.id }}</strong></td>
          <td v-if="$vuetify.breakpoint.width >= 991"><strong>{{ props.item.unidade[idioma] ? props.item.unidade[idioma] : 'UI/dia' }}</strong></td>

          <td><v-text-field
            value="-"
            readonly
            class="text-field-table input-disabled"
            color="primary"
            outline
          /></td>

          <td><v-text-field
            v-money="optionsNumber.float2[idioma]"
            :value="Object.values(props.item.alimentos).length ? props.item.total.toFixed(2) : '0.00'"
            readonly
            class="text-field-table input-disabled"
            color="primary"
            outline
          /></td>
          <td v-if="$vuetify.breakpoint.width >= 991"><v-text-field
            value="-"
            readonly
            class="text-field-table input-disabled"
            color="primary"
            outline
          /></td>
          <td>
            <v-text-field
              value="-"
              class="text-field-table input-disabled"
              readonly
              color="primary"
              outline
            />
          </td>

        </tr>
      </template>
      <template
        v-slot:expand="props"
        justify="center">
        <v-container

          v-show="Object.values(props.item.alimentos).length"
          p-0
          wrap
          flat>
          <v-card

            flat>

            <v-layout
              row
              wrap
              pr-1
              pl-1
              pt-2
              pb-3
            >
              <v-flex
                xs12
                md12
                lg12
                xl12
              >
                <v-data-table
                  :items="Object.values(props.item.alimentos)"
                  class="elevation-1 table-exigencias table-relatorio border-table-child"
                  item-key="id"
                  hide-actions
                  hide-headers
                >
                  <template v-slot:items="props">
                    <td xs6>
                      <strong>{{ idioma === 0 ? alimentos_selecionados[alimentos_selecionados.findIndex(el => el.id === props.item.id)].name : idioma === 1 ? alimentos_selecionados[alimentos_selecionados.findIndex(el => el.id === props.item.id)].name_en : alimentos_selecionados[alimentos_selecionados.findIndex(el => el.id === props.item.id)].name_es }}</strong>
                    </td>
                    <td xs6>
                      <v-text-field
                        v-money="renderMask(['', '', ''], props.item.unidade, idioma)"
                        v-if="parseFloat(props.item.valorUnidade.toFixed(2)) > 0"
                        :value="props.item.valorUnidade.toFixed(2)"
                        :sufix="props.item.unidade"
                        readonly
                        class="text-field-table input-disabled"
                        color="primary"
                        outline
                      />
                      <v-text-field
                        v-else
                        :value="(idioma === 0 || idioma === 2) ? '<0,01 ' + props.item.unidade[0] : '<0.01 ' + props.item.unidade[1]"
                        :sufix="props.item.unidade"
                        readonly
                        class="text-field-table input-disabled"
                        color="primary"
                        outline
                      />
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </template>
    </v-data-table>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import Color from 'color'
export default {
  props: {
    composicao_dieta: {
      type: Object,
      default: () => {}
    },
    composicao_racao: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    ingredientesComAditivos: []
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'optionsNumber', 'exigencias', 'exigencias_selecionadas', 'alimentos_selecionados', 'headersExigenciasRelatorio', 'headersExigenciasRelatorioPredicao', 'exigencias_resultados', 'tipo', 'ingredientesCompletos']),
    chartData () {
      return (ing = 'MS') => {
        if (ing === 'MS') ing = 'CMS'
        else if (!this.composicao_dieta[ing]) return
        let dados = [['Animal', 'Quantidade']]
        let c = 0
        for (let alimento of this.alimentos_selecionados) {
          console.log({ cd: this.composicao_dieta, ing })
          dados.push([ alimento[this.idioma === 0 ? 'name' : this.idioma === 1 ? 'name_en' : 'name_es'], parseFloat(this.composicao_dieta[ing]['alimentos'][alimento['id']] ? this.composicao_dieta[ing]['alimentos'][alimento['id']]['valor'] : 0) ])
          c++
          // dados.push([alimento.name, alimento.quantidade])
        }
        console.log({ dados })
        return dados
      }
    }
  },
  mounted () {
    this.getAditivos()
  },
  methods: {
    getAditivos () {
      this.axios.post('aditivos/getAditivos').then(r => {
        this.aditivos = r.data.data
        let ing = this.aditivos.map(a => {
          let res = {}
          res['id'] = 'AD|' + a.id
          res['exigencia'] = a.nome
          res['exigencia_en'] = a.nome_ingles
          res['exigencia_es'] = a.nome_espanhol
          res['unidade'] = a.unidade
          res['unidade_en'] = a.unidade
          res['unidade_es'] = a.unidade
          return res
        })
        this.ingredientesComAditivos = [...Object.values(this.ingredientesCompletos), ...ing]
      })
    },
    getCustoSalvo (alimento) {
      if (alimento.id === 'ID_LEITE_VACA') alimento.id = ID_LEITE_VACA
      if (alimento.id === ID_LEITE_VACA) return
      let custos = JSON.parse(localStorage.getItem('custos'))
      return (custos === null || (custos && custos[alimento.id] && custos[alimento.id].length === 0)) ? null : parseFloat(custos[alimento.id][custos[alimento.id].length - 1]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
    },
    parseString (valor, idioma) {
      return this.$parseString(valor, idioma)
    },
    renderInputStyle (total, min, max, nome) {
      try {
        min = this.parseString(min, this.idioma)
      } catch (e) {
        min = this.parseString(min.toFixed(2), this.idioma)
      }
      try {
        max = this.parseString(max, this.idioma)
      } catch (e) {
        max = this.parseString(max.toFixed(2), this.idioma)
      }
      var color = Color('#EEE')

      var erroMin = false
      var erroMax = false

      var erroRange = 0.1
      // verificar se as exigencias selecionadas é apenas CMS (caso seja, logo é predição);

      let exigencias = Array.from(this.exigencias_selecionadas)
      let tipo = exigencias.length > 1 ? 'FD' : 'PD'
      let todasExigencias = tipo === 'FD'
      if ((tipo === 'PD' && total >= min && total <= max) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total >= min && total <= max)) {
        color = Color('#EEE')
      } else if ((tipo === 'PD' && total < min) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total < min)) {
        this.$emit('dietaSemiOtima', { 'status': true, 'exigencia': nome })
        color = Color('#FE2E2E')
        erroMin = true
        let light = Math.abs(min - total) / (min)
        if (light < 1) {
          color = color.lighten(1 - light - 0.4)
        }
      } else if ((tipo === 'PD' && total > max) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total > max)) {
        this.$emit('dietaSemiOtima', { 'status': true, 'exigencia': nome })
        color = Color('#ffa500')
        erroMax = true
        let light = Math.abs(total - max) / (max)
        if (light < 1) {
          color = color.lighten(1 - light - 0.5)
        }
      } else {
        color = Color('#EEE')
      }
      return 'border: ' + ((erroMax || erroMin) ? (2 * (color.luminosity())) : 0) + 'px dotted ' + color.rgb().string() + '!important; background: ' + color.rgb().string() + ';'
    },
    renderInputTotal (total, min, max, nome) {
      var erroRange = 0.1
      try {
        min = this.parseString(min, this.idioma)
      } catch (e) {
        min = this.parseString(min.toFixed(2), this.idioma)
      }
      try {
        max = this.parseString(max, this.idioma)
      } catch (e) {
        max = this.parseString(max.toFixed(2), this.idioma)
      }
      // verificar se as exigencias selecionadas é apenas CMS (caso seja, logo é predição);
      let exigencias = Array.from(this.exigencias_selecionadas)
      let tipo = exigencias.length > 1 ? 'FD' : 'PD'
      let todasExigencias = tipo === 'FD'
      if ((tipo === 'PD' && total >= min && total <= max) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total >= min && total <= max)) return 'text-field-table input-disabled'
      else if ((tipo === 'PD' && total < min) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total < min)) {
        this.$emit('dietaSemiOtima', { 'status': true, 'exigencia': nome })
        let light = Math.abs(min - total) / (erroRange * min)
        return 'text-field-table input-disabled ' + ((light > 0.8) ? 'total-vazio' : (light > 0.4) ? 'total-vazio' : 'total-vazio')
      } else if ((tipo === 'PD' && total > max) || (tipo === 'FD' && (exigencias.includes(nome) || todasExigencias) && total > max)) {
        this.$emit('dietaSemiOtima', { 'status': true, 'exigencia': nome })
        let light = Math.abs(total - max) / (erroRange * max)
        return 'text-field-table input-disabled ' + ((light > 0.8) ? 'total-vazio' : (light > 0.4) ? 'total-vazio' : 'total-vazio')
      } else return 'text-field-table input-disabled'
    },
    renderMask (esq, dir, idioma) {
      return {
        decimal: (idioma === 0 || idioma === 2) ? ',' : '.',
        thousands: (idioma === 0 || idioma === 2) ? '.' : ',',
        precision: 2,
        prefix: (esq && esq[idioma] !== undefined) ? esq[idioma] + ' ' : ' ',
        suffix: (dir && dir[idioma] !== undefined) ? ' ' + dir[idioma] : ' '
      }
    },
    textAlignHeader (header, headers) {
      if (this.$vuetify.breakpoint.width >= 991) {
        if (header.text !== headers[0][3].text && header.text !== headers[0][4].text && header.text !== headers[0][5].text && header.text !== headers[0][6].text) return 'text-align: left; font-size: 16px'
        else return 'text-align: center; font-size: 16px'
      } else {
        if (header.text !== headers[1][1].text && header.text !== headers[1][2].text && header.text !== headers[1][3].text && header.text !== headers[1][4].text) return 'text-align: left; font-size: 16px'
        else return 'text-align: center; font-size: 16px'
      }
    }
  }
}
</script>
